import { useState } from 'react';
import { isBrowser } from 'acq-utils/lib/utils';
import useOnResize from 'src/universal/hooks/useOnResize';

/**
 * Returns a Boolean true if window.innerWidth is less than screenSmMax (767px)
 * Only works client side, and will return false on the server
 * @param {Number} screenSmMax - the max width for what is considered to be mobile. default is 767px.
 */

const useIsMobile = (screenSmMax = 767) => {
  const _isMobile = isBrowser() && window.innerWidth <= screenSmMax;
  const [isMobile, setIsMobile] = useState(_isMobile);

  useOnResize(() => {
    if (isMobile && window.innerWidth > screenSmMax) {
      setIsMobile(false);
    } else if (!isMobile && window.innerWidth <= screenSmMax) {
      setIsMobile(true);
    }
  });

  return isMobile;
};

export default useIsMobile;
